import _classCallCheck from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import { __rest as t } from "../../_virtual/_tslib.js";
import { jsx as e } from "react/jsx-runtime";
import { Component as r } from "react";
import o from "styled-components";
import { calculateRem as i } from "@vds-core/utilities";
import { ColorTokens as a } from "@vds-tokens/color";
import s from "./Scrollbars.js";
var c = o.span.withConfig({
  displayName: "Wrapper",
  componentId: "VDS__sc-gcdvly-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: ", ";\n  width: ", ";\n  &&,\n  * {\n    -ms-overflow-style: none;\n    scrollbar-width: none;\n    &::-webkit-scrollbar {\n      display: none;\n    }\n  }\n"])), function (_ref) {
  var t = _ref.height;
  return t;
}, function (_ref2) {
  var t = _ref2.width;
  return t;
});
var l = /*#__PURE__*/function (_r) {
  _inherits(l, _r);
  function l(r) {
    var _this;
    _classCallCheck(this, l);
    var o;
    _this = _possibleConstructorReturn(this, _getPrototypeOf(l).call(this, r)), o = _assertThisInitialized(_assertThisInitialized(_this)), _this._handleUpdate = function (t) {
      var e = t.top,
        r = t.scrollHeight,
        i = t.clientHeight;
      o.state.top === e && o.state.scrollHeight === r && o.state.clientHeight === i || o.setState({
        top: e,
        scrollHeight: r,
        clientHeight: i
      });
    }, _this._thumbHeight = function () {
      var _o$state = o.state,
        t = _o$state.clientHeight,
        e = _o$state.scrollHeight;
      return e ? t * o.state.clientHeight / e : 0;
    }, _this._changeBackground = function () {
      o.setState({
        hover: !o.state.hover
      });
    }, _this._calculateAlignment = function () {
      return o.props.hitAreaWidth / 2 - 2;
    }, _this.View = function (r) {
      var i = r.style,
        a = r.calculateThumbColor,
        s = r.calculateTrackColor,
        c = r.borderRadius,
        l = r.surface,
        n = r.hideTracksWhenNotNeeded,
        h = t(r, ["style", "calculateThumbColor", "calculateTrackColor", "borderRadius", "surface", "hideTracksWhenNotNeeded"]);
      var u = {
        display: "flex",
        boxSizing: "border-box",
        overflowX: "hidden",
        margin: 0,
        width: "100%",
        height: "100%",
        minHeight: o.props.minHeight
      };
      return e("div", Object.assign({
        id: "scrollbar-view-".concat(o.props.scrollbarId),
        style: Object.assign(Object.assign(Object.assign({}, i), u), o.props.contentStyle)
      }, h));
    }, _this.Track = function (r) {
      var i,
        a,
        s = r.style,
        c = r.calculateThumbColor,
        l = r.calculateTrackColor,
        n = r.borderRadius,
        h = r.surface,
        u = r.hideTracksWhenNotNeeded,
        d = t(r, ["style", "calculateThumbColor", "calculateTrackColor", "borderRadius", "surface", "hideTracksWhenNotNeeded"]);
      var p = o._thumbHeight() >= o.state.clientHeight,
        g = {
          backgroundColor: null === (a = (i = o.props).calculateTrackColor) || void 0 === a ? void 0 : a.call(i, o.props.surface),
          display: p ? "none" : "block",
          top: 0,
          right: 0,
          bottom: 0,
          width: 4,
          cursor: "pointer",
          borderRadius: o.props.borderRadius
        };
      return e("span", Object.assign({
        id: "scrollbar-track-".concat(o.props.scrollbarId),
        style: Object.assign(Object.assign({}, s), g),
        onMouseOver: o._changeBackground,
        onMouseOut: o._changeBackground
      }, d, {
        "aria-hidden": !0
      }));
    }, _this.HitArea = function () {
      var t = o._thumbHeight() >= o.state.clientHeight,
        r = {
          position: "absolute",
          top: 0,
          zIndex: 0,
          right: "-".concat(o._calculateAlignment(), "px"),
          width: "".concat(o.props.hitAreaWidth, "px"),
          height: "100%",
          display: t ? "none" : "flex",
          justifyContent: "center"
        };
      return e("span", {
        style: Object.assign({}, r),
        onMouseOver: o._changeBackground,
        onMouseOut: o._changeBackground
      });
    }, _this.Thumb = function (r) {
      var i,
        a,
        s = r.style,
        c = r.calculateThumbColor,
        l = r.calculateTrackColor,
        n = r.borderRadius,
        h = r.surface,
        u = r.hideTracksWhenNotNeeded,
        d = t(r, ["style", "calculateThumbColor", "calculateTrackColor", "borderRadius", "surface", "hideTracksWhenNotNeeded"]);
      var p = o.state.hover,
        g = {
          backgroundColor: null === (a = (i = o.props).calculateThumbColor) || void 0 === a ? void 0 : a.call(i, o.props.surface, p),
          height: "100%",
          width: 4,
          left: "".concat(o._calculateAlignment(), "px"),
          borderRadius: o.props.borderRadius
        },
        b = {
          cursor: "grab",
          width: "".concat(o.props.hitAreaWidth, "px"),
          left: "-".concat(o._calculateAlignment(), "px"),
          zIndex: 1,
          textAlign: "center"
        };
      return e("span", Object.assign({
        style: Object.assign(Object.assign({}, s), b),
        onMouseOver: o._changeBackground,
        onMouseOut: o._changeBackground
      }, d, {
        children: e("span", Object.assign({
          style: Object.assign(Object.assign({}, s), g)
        }, d))
      }));
    }, _this.state = {
      scrollHeight: 0,
      clientHeight: 0,
      hover: !1,
      top: 0,
      scroll: !1
    }, _this.scrollRef = null;
    return _this;
  }
  _createClass(l, [{
    key: "render",
    value: function render() {
      var r = this;
      var o = this.props,
        i = t(o, ["contentStyle", "calculateThumbColor", "calculateTrackColor", "borderRadius", "surface", "scrollbarId", "hitAreaWidth"]);
      return e(c, {
        height: this.props.height,
        width: this.props.width,
        children: e(s, Object.assign({
          style: Object.assign(Object.assign({}, this.props.wrapperStyle), {
            height: this.props.height,
            width: this.props.width,
            minHeight: this.props.minHeight
          }),
          id: "scrollview-".concat(this.props.scrollbarId),
          ref: function ref(t) {
            r.scrollRef = t;
          },
          renderView: this.View,
          renderTrackVertical: this.Track,
          renderThumbVertical: this.Thumb,
          renderTrackHorizontal: function renderTrackHorizontal() {
            return e("span", {
              "aria-hidden": !0
            });
          },
          renderThumbHorizontal: function renderThumbHorizontal() {
            return e("span", {});
          },
          renderHitArea: this.HitArea,
          onUpdate: this._handleUpdate
        }, i, {
          children: this.props.children
        }))
      });
    }
  }]);
  return l;
}(r);
l.defaultProps = {
  calculateTrackColor: function calculateTrackColor(t) {
    var e;
    return e = "dark" === t ? a.interactive.scrolltrack.ondark.value : a.interactive.scrolltrack.onlight.value, e;
  },
  calculateThumbColor: function calculateThumbColor(t, e) {
    var r;
    return r = "dark" !== t || e ? e && "dark" !== t ? a.interactive.scrollthumb.hover.onlight.value : e && "dark" === t ? a.interactive.scrollthumb.hover.ondark.value : a.interactive.scrollthumb.onlight.value : a.interactive.scrollthumb.ondark.value, r;
  },
  borderRadius: i(2),
  hitAreaWidth: 44
};
export { l as default };